// extracted by mini-css-extract-plugin
module.exports = {"footer":"CheckPostalCodeSheet_footer__DlgCZ"};